var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shane_tm_all_wrap",attrs:{"id":"app"}},[_c('router-view'),_c('back-top',{attrs:{"color":"#fff","size":1.2,"bottom":"5%","slow":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }